<div class="share-choose-owner">
    <sync-dialog
      [config]="{
        title: 'Change owner',
        subTitle: name,
        isClosable: true,
        closeIcon:'arrow-left',
        onCloseIcon: onBack,
        cancelButton: 'Back',
        onCancelClick: onBack,
        actionButton: 'Transfer', 
        onActionClick: onTransfer,
        isButtonLoading: spinner,
        isActionButtonDisabled:!selectedMember,
      }"
      [open]="showDialog"
      [isFullScreen]="isSmallScreen"
    >
    <div class="share-choose-owner-container">
        <sync-alert [type]="'warning'" [leadIcon]="'warning'" [showLeadIcon]="true" [title]="'Warning'" 
        [description]="'You are about to change the ownership of your shared folder to the share member selected below. After this change you will still have access to the share folder, but permissions will no longer be managed by you. This action cannot be undone.'" [showActions]="false" [showPrimaryAction]="false" [showSecondaryAction]="false" [showCloseButton]="false"
        ></sync-alert>
        <sync-select
        [label]="'New owner'"
        [list]="members"
        [value]="selectedMember" [onSelectionChange]="onMemberChange"
        ></sync-select>
    </div>
</sync-dialog>
</div>